<template>
    <div class="my-number flex justify-center align-center">
		<div class="p-content flex align-center flex-wrap justify-between" style="padding-left: 100px;">
		    <div
		        v-for="(item, i) in list"
		        :key="'list' + i"
				v-if="i < 2"
		        :class="['item flex justify-center flex-direction']"
                style="padding: 0 0 0 90px;width: 240px;">
		        <img class="item-c" :src="item.icon" alt="" />
                <dv-digital-flop style="height: 50px; width: 200px" :config="dvDigitalFlopConfig(item)" />
		        <div class="item-l mt-10" style="font-size: 38px;">{{ item.label }}</div>
		    </div>
		</div>
        <div style="padding:0 60px 0 0px">当前算力</div>
            <div
            v-for="(item, i) in showNumber"
            :key="'showNumber' + i"
            class="flex number-content align-center">
            <div
                v-for="(num, x) in item"
                :key="'num' + x"
                class="flex number-box justify-center align-center">
                {{ num }}
            </div>
            <div
                v-if="i != showNumber.length - 1"
                class="number-unit flex flex-direction align-center">
                <span class="separat">,</span>
                <span class="unit">{{ unit[i] }}</span>
            </div>
        </div>
        <div style="padding:0 0px 0 60px">次/秒</div>
		<div class="p-content-1 flex align-center flex-wrap justify-between" style="padding-left: 120px;">
		    <div
		        v-for="(item, i) in list"
		        :key="'list' + i"
				v-if="i > 1  && item.label != '大模型数量'"
		        class="item flex justify-center flex-direction" style="padding: 0 0 0 90px; width: 240px;">
		        <img class="item-c" :src="item.icon" alt=""/>
                <dv-digital-flop style="height: 50px; width: 200px" :config="dvDigitalFlopConfig(item)" />
		        <div class="item-l mt-10" style="font-size: 38px;">{{ item.label }}</div>
		       
		    </div>
		</div>
    </div>
</template>

<script>
let numberUnit = ['P', 'T', 'G', 'M', 'K']
import { dataInterface } from '@/api/dataInterfaceApi';
export default {
    // props: {
    //     number: {
    //         type: [String, Number],
    //         default: '12345678901'
    //     }
    // },
    data() {
        return {
            unit: [],
            showNumber: [],
            timer: null,
			list: [],
            timer1: null
        }
    },
    async mounted() {
        await this.selectComprehensiveSituation()
        await this.getData()
        // this.timer = setInterval(() => {
        //     this.getData()
        //     this.selectComprehensiveSituation()
        // }, 2000)
    },
    methods: {
		// 字体动态
		dvDigitalFlopConfig(item = {}) {
		    let counts = parseFloat(item.value || 0)
		    let config = {
		        number: [parseFloat(counts)],
		        textAlign: item.textAlign || 'center',
		        content: `{nt}%`,
		        style: {
		            fill: item.color || '#fff',
		            fontSize: item.fontSize || 72,
					fontFamily: 'DS-Digital-Bold'
		        }
		    }
		    console.log('==config==', config)
		    return config
		},
        setNumber() {
            let numnber =  String(this.number)
            this.showNumber = numnber.split('').reverse().join('').match(/(\d{1,3})/g).reverse().map(item => {
                return item.split('').reverse()
            }) || []
            this.unit = JSON.parse(JSON.stringify(numberUnit)).reverse().splice(0, this.showNumber.length - 1).reverse()
            let maxL = this.showNumber.length - this.unit.length
            if(maxL > 0) {
                let oneA = []
                for(let x = 0; x < maxL - 1; x++) {
                    // oneA.push(showNumber[x])
                    this.unit.unshift('')
                }
                // this.showNumber = [oneA.flat(2), ...showNumber.splice(0, maxL)]
            }
            // debugger
            // console.log('tem', temp)
        },
        selectComprehensiveSituation(data={}){ 
            let _this = this;
            let params = { 
                enCode: 'computingpower-mid-dqsl-new',
            }
            dataInterface
            .dataFaceApi(params)
            .then((res) => {
                if(!res) return;
                console.log(res[0],'当前算力2')
                let { current_power } = res[0] || {}
                this.number = current_power
                this.setNumber()
            })
            .catch((err) => {
                console.log(err);
            });
        },
		// 实时负载
		getData() {
			let params = { 
				enCode: 'computingpower-right-ssfz',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '实时负载020202')
		        let data = res || []
		        // this.list[0].value = data
		        // let colors = [ '#28C89A', '#FFFFFF', '#FFD15C', '#FFD15C' ]
				this.list = data.map((item, i) => {
		            let icon = item.type == 'CPU' || item.type == 'GPU' ? item.type : (item.type == '内存' ? 'RAM' : 'memory')
		            return {
		                label: item.type,
		                value: item.load,
		                color: '#03B9BD', //colors[i],
		                icon: require(`@/assets/images/computility/monitor-icon-${icon}.png`),
		                textAlign: 'left',
		            }
		        })
			})
		}
    },
	destroyed () {
	    console.log('destroyed')
	    clearInterval( this.timer )
        // clearInterval( this.timer1 )
	}
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.my-number {
    width: 100%;
    font-size: $FontSize40;
    height: 240px;
    > div {
        // margin: 0 60px;
    }
    .number-content {
        margin: 0;
    }
    .number-box {
        width: 70px;
        height: 76px;
        font-size: $FontSize76;
        @include ffamily-DS;
        color: #00FDF4;
        background: url(~@/assets/images/computility/monitor-icon13.png) no-repeat;
        background-size: 100% 100%;
        margin: 0 10px;
    }
    .number-unit {
        position: relative;
        width: 0;
        height: 76px;
        padding-top: 30px;
        .separat {
            font-size: $FontSize60;
            line-height: 60px;
        }
        .unit {
            font-size: $FontSize24;
        }
    }

    .p-content{
        margin: 0;
    }
    // .cl-fam {
    //     @include ffamily-PMZD;
    // }
}


.p-content-1,.p-content {
        width: 750px;
        height: 140px;
		padding-top: 70px;
        .item {
            width: 50%;
            font-size: $FontSize32;
            padding: 10px 0 10px 100px;
            position: relative;
            .item-c {
                position: absolute;
                // width: 200px;
                // height: 200px;
                top: 50%;
                left: -50px;
                transform: translate(0, -50%);
                width: 120px;
            }
        }
    }
    .p-content-1{
        width: 800px;
    }
</style>